var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import RichText from '@/views/announcement/RichText/RichText1.vue';
import { getCommbookContent, validCommbookContent } from '@/common/video/commbookContent';
import AttachmentStrip from './attachment-strip.vue';
import { sendReply } from '../api';
import { safeUrl } from '../utils';
var savedHeights = {};
export default Vue.extend({
    name: 'GlobalCommbookReplyComposer',
    components: { RichText: RichText, AttachmentStrip: AttachmentStrip },
    props: {
        conversationId: { type: String, required: true },
        onSent: { type: Function, required: true }
    },
    data: function () {
        return {
            html: '',
            files: [],
            uploads: [],
            composerHeight: savedHeights[this.conversationId] || 225,
            sending: false,
            videoUploading: false,
            alive: true,
            error: '',
            resizeStartY: 0,
            resizeStartHeight: 0
        };
    },
    computed: {
        contentError: function () {
            var content = getCommbookContent(this.html);
            if (content.hasInvalidMedia)
                return 'Please remove or upload the unavailable image or video again.';
            return content.characterCount > 4000 ? 'Character limit of 4000' : '';
        },
        hasAttachmentStrip: function () {
            return !!(this.files.length || this.uploads.length);
        },
        editorHeight: function () {
            return Math.max(100, this.composerHeight - 96 - (this.hasAttachmentStrip ? 82 : 0));
        },
        count: function () {
            return getCommbookContent(this.html).characterCount;
        },
        hasContent: function () {
            return getCommbookContent(this.html).hasContent || !!this.files.length;
        },
        canSend: function () {
            return (this.alive &&
                !this.sending &&
                !this.videoUploading &&
                !this.uploads.length &&
                validCommbookContent(this.html, this.files));
        }
    },
    beforeDestroy: function () {
        this.alive = false;
        this.sending = false;
        this.videoUploading = false;
        this.stopResize();
    },
    methods: {
        onVideoUploading: function (busy) {
            if (!this.alive || this.sending)
                return;
            this.videoUploading = busy;
        },
        onHtml: function (html) {
            if (!this.alive || this.sending)
                return;
            this.html = html || '';
            this.error = '';
        },
        onFile: function (value) {
            if (!this.alive || this.sending)
                return;
            var input = Array.isArray(value) ? value : [value];
            var normalized = input.reduce(function (result, file) {
                if (!file || typeof file !== 'object')
                    return result;
                var src = safeUrl(file.src);
                if (src)
                    result.push({
                        src: src,
                        fileName: String(file.fileName || file.name || 'Attachment'),
                        size: Number(file.size) || undefined
                    });
                return result;
            }, []);
            var completedIds = input
                .filter(function (file) { return file && file.uid != null && safeUrl(file.src); })
                .map(function (file) { return String(file.uid); });
            this.uploads = this.uploads.filter(function (upload) { return !completedIds.includes(upload.id); });
            if (Array.isArray(value))
                this.files = normalized;
            else if (normalized.length && !this.files.some(function (file) { return file.src === normalized[0].src; }))
                this.files.push(normalized[0]);
            if (this.files.length && this.composerHeight < 292)
                this.resizeBy(292 - this.composerHeight);
            this.error = '';
        },
        onUploadStart: function (upload) {
            if (!this.alive || this.sending)
                return;
            this.uploads.push(__assign(__assign({}, upload), { percent: null, status: 'uploading', error: '' }));
            if (this.composerHeight < 292)
                this.resizeBy(292 - this.composerHeight);
            this.error = '';
        },
        onUploadProgress: function (event) {
            if (!this.alive || this.sending)
                return;
            var upload = this.uploads.find(function (item) { return item.id === event.id; });
            if (!upload || upload.status === 'error')
                return;
            upload.percent = event.percent;
            upload.status = event.percent === 100 ? 'processing' : 'uploading';
        },
        onUploadError: function (event) {
            if (!this.alive || this.sending)
                return;
            var upload = this.uploads.find(function (item) { return item.id === event.id; });
            if (!upload)
                return;
            upload.status = 'error';
            upload.error = event.message;
        },
        removeUpload: function (id) {
            if (!this.alive || this.sending)
                return;
            this.uploads = this.uploads.filter(function (upload) { return upload.id !== id; });
        },
        removeFile: function (index) {
            if (this.alive && !this.sending)
                this.files.splice(index, 1);
        },
        resizeBy: function (delta) {
            var minimum = this.hasAttachmentStrip ? 292 : 210;
            var maximum = Math.max(minimum, window.innerHeight - 240);
            this.composerHeight = Math.min(maximum, Math.max(minimum, this.composerHeight + delta));
            savedHeights[this.conversationId] = this.composerHeight;
        },
        startResize: function (event) {
            event.preventDefault();
            this.resizeStartY = event.clientY;
            this.resizeStartHeight = this.composerHeight;
            document.addEventListener('mousemove', this.onResize);
            document.addEventListener('mouseup', this.stopResize);
        },
        onResize: function (event) {
            var target = this.resizeStartHeight + this.resizeStartY - event.clientY;
            this.resizeBy(target - this.composerHeight);
        },
        stopResize: function () {
            document.removeEventListener('mousemove', this.onResize);
            document.removeEventListener('mouseup', this.stopResize);
        },
        setEditorEnabled: function (enabled) {
            var editor = this.$refs.editor;
            if (editor && editor.editor)
                editor.editor.setEditable(enabled);
        },
        send: function () {
            return __awaiter(this, void 0, void 0, function () {
                var conversationId, onSent, isCurrent, html, files, editor, error_1, error_2;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.canSend)
                                return [2 /*return*/];
                            this.sending = true;
                            this.setEditorEnabled(false);
                            this.error = '';
                            conversationId = this.conversationId;
                            onSent = this.onSent;
                            isCurrent = function () { return _this.alive && _this.conversationId === conversationId; };
                            html = getCommbookContent(this.html).html;
                            files = this.files.slice();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 7, 8, 9]);
                            return [4 /*yield*/, sendReply(conversationId, html, files)];
                        case 2:
                            _a.sent();
                            if (!isCurrent())
                                return [2 /*return*/];
                            this.html = '';
                            this.files = [];
                            this.uploads = [];
                            editor = this.$refs.editor;
                            if (editor && editor.clearHtml)
                                editor.clearHtml();
                            _a.label = 3;
                        case 3:
                            _a.trys.push([3, 5, , 6]);
                            return [4 /*yield*/, onSent(conversationId)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 6];
                        case 5:
                            error_1 = _a.sent();
                            if (isCurrent())
                                this.error = 'Message sent. Refresh the conversation to view it.';
                            return [3 /*break*/, 6];
                        case 6: return [3 /*break*/, 9];
                        case 7:
                            error_2 = _a.sent();
                            if (isCurrent())
                                this.error = error_2 instanceof Error ? error_2.message : 'Unable to send. Please try again.';
                            return [3 /*break*/, 9];
                        case 8:
                            if (isCurrent()) {
                                this.sending = false;
                                this.setEditorEnabled(true);
                            }
                            return [7 /*endfinally*/];
                        case 9: return [2 /*return*/];
                    }
                });
            });
        }
    }
});
